(() => {
  const roots = document.querySelectorAll('[data-swm26-team]');
  if (!roots.length) return;

  const isTouchDevice = window.matchMedia && window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  if (!isTouchDevice) return;

  const closeAll = (root, exceptCard = null) => {
    root.querySelectorAll('[data-team-card].is-open').forEach((card) => {
      if (exceptCard && card === exceptCard) return;
      card.classList.remove('is-open');

      const overlay = card.querySelector('[data-team-overlay]');
      if (overlay) overlay.setAttribute('aria-hidden', 'true');
    });
  };

  roots.forEach((root) => {
    const cards = Array.from(root.querySelectorAll('[data-team-card]'));
    if (!cards.length) return;

    cards.forEach((card) => {
      card.addEventListener('click', (e) => {
        const clickedInteractive = e.target.closest('a, button');
        if (clickedInteractive) return;

        const isOpen = card.classList.contains('is-open');

        closeAll(root, card);

        if (isOpen) {
          card.classList.remove('is-open');
          const overlay = card.querySelector('[data-team-overlay]');
          if (overlay) overlay.setAttribute('aria-hidden', 'true');
          return;
        }

        card.classList.add('is-open');
        const overlay = card.querySelector('[data-team-overlay]');
        if (overlay) overlay.setAttribute('aria-hidden', 'false');
      });

      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          card.click();
        }

        if (e.key === 'Escape') {
          closeAll(root);
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (root.contains(e.target)) return;
      closeAll(root);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      closeAll(root);
    });
  });
})();
